<template>
  <div class="row-100 mt-3" :key="updateDom">
    <template v-if="showSessionList">
      <h6 class="m-bold pl-2">
        Sessions
        <i v-if="counsellorView" @click="addCalendarAppointment()" title="Add New Session " class="pt-5px fa-solid fa-calendar-plus pull-right primary-color pointer" style="z-index:9999; position: relative;"></i>
      </h6>
      <hr class="w-100 theme_color" style="margin-top:8px"/>
     <div class="row">
    </div>
      <div class="table_scroll">
        <div class="row w-100 mb-3 m-0">
          <template v-for="(session, index) of sessionList">
            <div class="col-12 p-0" :key="index+session.session_id+session.session_state">
              <iq-card class="seesionBoxes">
                <div class="task-indicator" :style="{ backgroundColor: getSessionStatus(getSessionData(session, 'time')).color }"></div>
                <div class="card-body">
                  <div class="col-12">
                    <h6>{{ getSessionData(session, 'title') }}</h6>
                  </div>

                  <div class="col-12">
                    <small>Hosting Platform: {{ getSessionData(session, 'platform') }}</small>
                    <span class="float-right" v-if="session.slot_start_ts >= Math.floor(Date.now() / 1000) && getSessionData(session, 'link')">
                      <a @click="goToMeeting(getSessionData(session, 'link'))" class="mb-0 fw-bold pointer primary-color text-muted">Join Meeting</a>
                    </span>
                  </div>

                  <div class="col-12 mb-1">
                    <span class="badge text-white px-2 py-1" :style="{ backgroundColor: getCategoryColor(getSessionData(session, 'category')) }">
                      {{ getSessionData(session, 'category') }}
                    </span>
                  </div>

                  <div class="col-12">
                    <span style="display:block;">
                      <small>by {{session.counsellor_name}}<br>{{getSessionData(session, 'time') | dateFormatDDMMYYYYHHMMA}}</small>
                    </span>
                      <div class="buttons_right">
                        <span v-if="counsellorView" class="mr-2 pointer small pt-1" @click="spcmCalendarEditV1(session)">
                          <i class="fa-solid fa-calendar-check-o font-size-18"></i><!-- Edit Calendar -->
                        </span>
                        <span v-if="counsellorView" class="mr-2 pointer small pt-1" @click="addSpcmNote(session, 0)">
                          <i class="fa-solid fa-circle-plus font-size-18 primary-color" title="Counselor Private Notes"></i><!-- private Notes -->
                        </span>
                        <span v-if="counsellorView" class="mr-2 pointer small pt-1" @click="addSpcmNote(session, 1)">
                          <i class="fa-solid fa-circle-plus font-size-18 warning-color" title="Student/Parent Viewing Public Notes"></i><!-- public Notes -->
                        </span>
                    </div>
                  </div>
                </div>
              </iq-card>
            </div>
          </template>
        </div>
      </div>
    </template>

    <b-modal v-model="showModelSpcmSessionDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{ delObj.session_title }} <br>
        {{delObj.session_start_ts | dateFormatDDMMYYYYHHMMA}}
      </p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelSpcmSessionDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="SpcmSessionDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelSpcmCalenderAdd" scrollable :title="cvAddModalHeader" size="lg">
      <SpcmCalenderAddV1 :propOpenedInModal="true" :propSpcmId=propSpcmObj.spcm_id :propUserId="propStudentData ? propStudentData.user_id : null" :propActivity="true" @emitCloseSpcmCalenderAddModal="closeSpcmCalenderAddModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeSpcmCalenderAddModal()">{{cvbtnModalCancel}}</b-button>
      </template>
    </b-modal>

    <b-modal
        v-model="showModelSpcmCalenderEdit"
        scrollable
        :title="cvEditModalHeader"
        size="lg"
      >
        <SpcmCalenderEditV1 :propActivity="true" :propOpenedInModal="true" :propSessionEdit="true" :propSpcmCalenderId="spcmCalendarEditId" :propSpcmCalenderObj="spcmCalendarEditObj" @emitCloseSpcmCalenderEditModal="closeSpcmCalenderEditModal" @emitEditFails="editFails()" />
        <template #modal-footer="">
          <b-button size="sm" class="pull-left" @click="spcmCalendarEdit('FULLPAGE')">
            {{cvbtnModalExpand}}
          </b-button>
          <b-button size="sm" @click="closeSpcmCalenderEditModal()">
            {{cvbtnModalCancel}}
          </b-button>
        </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import { SpcmCalenders } from "../FackApi/api/SpcmCalender.js"
import { SpcmSessions } from "../FackApi/api/spcmSession.js"
import { Subscriptions } from "../FackApi/api/Subscription/subscription.js"
import ApiResponse from "../Utils/apiResponse.js"
import SPCMSessionHostingPlatForm from "../FackApi/json/SPCMSessionHostingPlatForm.json"
import moment from "moment"
import { EventBus } from "../main.js"
import { User } from "../FackApi/api/user.js"
import getEventHostingPlatformByRole from "../FackApi/json/EventHostingPlatforms"
import SpcmCalenderAddV1 from "../../src/views/Gide/SPCM/SpcmCalenderAddV1.vue"
import SpcmCalenderEditV1 from "../../src/views/Gide/SPCM/SpcmCalenderEditV1.vue"
import { SpcmCalendarCategorys } from "../FackApi/api/SpcmCalendarCategory.js"

export default {
  name: "SpcmSessionAddEdit",
  components: {
    SpcmCalenderEditV1,
    SpcmCalenderAddV1
  },
  props: {
    propSpcmId: {
      default: null
    },
    propSessionId: {
      default: null
    },
    propSpcmObj: {
      default: null
    },
    propViewList: {
      default: false
    },
    propStudentData: {
      default: null
    }
  },
  data () {
    return {
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      vmSessionForm: {
        session_hosting_platform: SPCMSessionHostingPlatForm.ZOOM
      },
      availableSlotList: [],
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      showPaymentModal: false,
      toastTitle: "Counseling Session",
      modName: "counselling", // Mapped to the Table modules. Used to chheck if this module is used in subscription or not
      subModuleName: null,
      SPCMSessionHostingPlatForm: SPCMSessionHostingPlatForm,
      counsellorView: false,
      studentView: false,
      showSessionList: false,
      sessionList: [],
      currentUtcTs: moment().utc().valueOf() / 1000,
      newSessionId: null,
      updateDom: 0,
      cvCounsellorOptions: [],
      counsellorId: null,
      showModelSpcmCalenderAdd: false,
      showModelSpcmCalenderEdit: false,
      cvAddModalHeader: "Setup a Meeting",
      cvbtnModalCancel: "Close",
      cvbtnModalDelOk: "Delete",
      delObj: {},
      showModelSpcmSessionDelete: false,
      productName: "spcm",
      whereFilter: {},
      spcmCalendarEditObj: null,
      spcmCalendarEditId: null,
      cvbtnModalExpand: "Expand",
      spcmCalendarCategory: [],
      cvEditModalHeader: "Edit Calender"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    this.productName = this.$route.path.includes("testseries") ? "testseries" : this.productName

    if (this.userData.user_role == "USERROLE11118" || this.userData.user_role == "USERROLE11111") {
      this.counsellorView = true
    }
    else if (this.userData.user_role == "USERROLE11114") {
      this.studentView = true
    }

    if (this.propViewList) {
      this.showSessionList = true
    }

    if (this.propSpcmObj && this.propSpcmObj.spcm_total_session < 2) {
      this.subModuleName = this.propSpcmObj.spcm_total_session == 1 ? `session_two` : "session_one" // take next session plan
      this.subscriptionModRuleAvailableCheck(this.subModuleName)
    }

    if (this.propSpcmObj && this.propSpcmObj.spcm_total_session >= 0) {
      this.getSessionList()
    }

    await this.getSpcmCalendarCategoryList()
    this.getAvailableSlots({ user_id: this.propSpcmObj.counsellor_id })
  },
  methods: {
    getSessionStatus (timestamp) {
      if (!timestamp) return { label: "No Date", color: "#6c757d" }

      const sessionDate = moment.unix(timestamp)

      const today = moment().startOf("day")
      const tomorrow = moment().endOf("day")

      if (sessionDate.isBefore(today)) {
        return { label: "Meeting Over", color: "#ff4d4d" } // Red
      }
      else if (sessionDate.isSameOrAfter(today) && sessionDate.isSameOrBefore(tomorrow)) {
        return { label: "Meeting Today", color: "#28a745" } // Green
      }
      else {
        return { label: "Meeting Scheduled", color: "#ffa500" } // Orange
      }
    },
    /**
   * Show spcm session data on priority basis. If session data is not available then show calendar data
   */
    getSessionData (session, field) {
      if (!session) return ""

      const fields = {
        title: session.session_title || session.title || "Untitled Session",
        platform: session.session_hosting_platform || session.calendar_hosting_platform || "N/A",
        link: session.session_meeting_link || session.calendar_meeting_link || "",
        time: session.session_start_ts || session.slot_start_ts || null,
        category: session.category || "General"
      }

      return fields[field] ?? ""
    },
    /**
     * Go To Meeting Link
     */
    goToMeeting (url) {
      window.open(url, "_blank")
    },
    /* eslint-disable */
    sessionCustomLabel ({ slot_start, slot_end }) {
      return `${slot_start} - ${slot_end}`
    },
    /* eslint-enable */
    /**
     * getCounsellorList
     */
    async getCounsellorList () {
      const payload = {
        user_role: "USERROLE11118" // counsellor
      }
      const apiResp = await User.userListSearch(this, payload)
      if (apiResp.resp_status) {
        this.cvCounsellorOptions = apiResp.resp_data.data
      }
    },
    /**
     * showSessionList
     */
    showSessionListFn () {
      this.showSessionList = true
      this.vmSessionForm = {}
    },
    /**
     * getSessionList
     */
    async getSessionList () {
      try {
        const sessionListApiResp = await SpcmSessions.spcmSessionList(this, { spcm_id: this.propSpcmId })
        if (sessionListApiResp.resp_status) {
          this.sessionList = [ ...sessionListApiResp.resp_data.data ]
        }
        else {
          await this.spcmSessionAdd()
        }

        this.updateDom += 1
      }
      catch (error) {
        console.error("Exception in getSessionList()", error)
      }
    },
    /**
     * spcmSessionAdd
     */
    async spcmSessionAdd () {
      // Add a spcm session
      const spcmAddResp = {
        user_id: this.propSpcmObj.counsellor_id,
        participant_id: this.propSpcmObj.user_id,
        spcm_id: this.propSpcmObj.spcm_id,
        session_title: "session 1",
        session_hosting_platform: getEventHostingPlatformByRole()["OTHER"],
        counsellor_id: this.propSpcmObj.counsellor_id,
        session_start_ts: moment().unix(),
        session_end_ts: moment.unix() + 3600,
        session_state: 0 // not paid Yet
      }
      const spcmSessionAddResp = await SpcmSessions.spcmSessionAdd(this, spcmAddResp)
      if (spcmSessionAddResp.resp_status) {
        this.getSessionList()
      }
    },
    /**
     * emitPaymentStatus
     */
    emitPaymentStatus (event) {
      this.showPaymentModal = false
      if (event && (event.includes("Captured") || event.includes("Success"))) {
        if (this.$route.query.module_name) {
          this.$router.push(`/spcm/`)
        }
        else {
          window.location.reload() // @tobe remove
        }
      }
    },
    /**
     * getAvailableSlots
     */
    async getAvailableSlots (counsellor) {
      this.availableSlotList = []
      let payload = {
        counsellor_id: counsellor.user_id
      }
      this.counsellorId = counsellor.user_id

      const sessionListApiResp = await SpcmCalenders.spcmCalendarList(this, payload)
      if (sessionListApiResp.resp_status) {
        this.availableSlotList = sessionListApiResp.resp_data.data

        if (this.vmSessionForm.slot && typeof this.vmSessionForm.slot == "number") {
          const findIndex = this.availableSlotList.findIndex(ele => ele.slot_start_ts == this.vmSessionForm.slot)
          if (findIndex >= 0) {
            this.vmSessionForm.slot = this.availableSlotList[findIndex]
          }
        }
      }
    },
    /**
     * subscriptionModRuleAvailableCheck
     */
    async subscriptionModRuleAvailableCheck (subModuleName) {
      try {
        const ruleAvailableResp = await Subscriptions.subscriptionModRuleAvailableCheck(this, { mod_name: this.modName, sub_mod_name: subModuleName })
        if (ruleAvailableResp.resp_status) {
          this.modAvailable = ruleAvailableResp.resp_data.data
        }
      }
      catch (error) {
        console.error("subscriptionModRuleAvailableCheck Exception", error)
      }
    },
    /**
     * joinMeeting
     */
    async joinMeeting (session) {
      window.open(session.session_meeting_link, "_blank")
    },
    /**
     * addSession
     */
    async addSession () {
      let addSessionApi = true

      if (this.vmSessionForm.counsellor && this.vmSessionForm.counsellor.user_id) {
        // Session is not mandatory, so if a session is not added, create a session with the current timestampS
        if (!this.vmSessionForm.slot) {
          this.vmSessionForm.slot = {
            spcm_calendar_id: "SPCM" + Math.floor(100000 + Math.random() * 900000), // Generating a random spcm_calendar_id
            slot_start_ts: moment().unix(), // setting the slot start time to current timestamp
            slot_duration: 3600000 // default duration of 1hr
          }
        }

        let payload = {
          session_id: this.vmSessionForm.session_id,
          session_title: this.vmSessionForm.session_title ? this.vmSessionForm.session_title : `Session ${this.sessionList.length + 1}`,
          spcm_id: this.propSpcmId,
          session_start_ts: this.vmSessionForm.slot.slot_start_ts,
          session_end_ts: Number(this.vmSessionForm.slot.slot_start_ts) + this.vmSessionForm.slot.slot_duration,
          session_hosting_platform: this.vmSessionForm.session_hosting_platform,
          session_meeting_link: this.vmSessionForm.session_meeting_link,
          counsellor_id: this.userData.user_id,
          spcm_calendar_id: this.vmSessionForm.slot.spcm_calendar_id,
          session_state: null,
          user_email: this.propStudentData.user_email,
          user_id: this.vmSessionForm.counsellor.user_id,
          participant_id: this.propStudentData.user_id
        }

        let apiResp = null
        if (this.counsellorView && this.vmSessionForm.session_id) {
          addSessionApi = false
          apiResp = await SpcmSessions.spcmSessionEdit(this, payload)
        }
        else {
          if (this.propSpcmObj.spcm_total_session < 2) {
            payload.session_state = 0
          }
          else {
            payload.session_state = 2 // Sessionn confirmed
          }
          addSessionApi = true
          apiResp = await SpcmSessions.spcmSessionAdd(this, payload)
        }

        ApiResponse.responseMessageDisplay(this, apiResp)

        if (apiResp.resp_status) {
          this.showSessionList = true
          this.getSessionList()
        }
        else if (apiResp.resp_code === "ERR_SUBS_PLAN_PURCHASE_REQUIRED" || apiResp.resp_code === "ERR_SUBS_PLAN_LIMIT_OVER") {
          this.showPaymentModal = true
          this.showSessionList = true
          this.newSessionId = apiResp.resp_data.session_id
          return
        }

        if (addSessionApi) {
          this.$emit("emitSessionUpdated", apiResp.resp_data)
          this.sessionList.push(apiResp.resp_data)
          this.updateDom += 1
        }
      }
      else {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "Counsellor is not selected for the session"
      }
    },
    /**
     * addSpcmNote
     */
    async addSpcmNote (session, isPublic = 0) {
      try {
        let payload = {
          user_id: this.userData.user_id,
          gide_user_id: this.propSpcmObj.user_id,
          counsellor_id: this.propSpcmObj.counsellor_id,
          // "note_id": "NOTE03b4e103fb5e49f8803ed21332b9e883",
          spcm_id: session.spcm_id,
          session_id: session.session_id,
          note_type: 1, // 1 for note and 2 for comment
          note_public_type: isPublic,
          notes_module_obj_id: this.propStudentData.user_id
        }

        // Emit to the Notes Add Component
        EventBus.$emit("emitNoteAdd", { payload, session_title: session.session_title, session_start_ts: session.session_start_ts, propPublicType: isPublic })
      }
      catch (error) {
        console.error("Exception in addSpcmNote()", error)
      }
    },
    /**
     * sessionStateChange
     */
    async sessionStateChange (session, sessionState) {
      try {
        let payload = {
          session_id: session.session_id,
          session_state: null,
          counsellor_id: this.counsellorView ? this.propSpcmObj.counsellor_id : null
        }

        switch (sessionState) {
          case "CONFIRM_MEETING":
            payload.session_state = 2 // Meeting Confirmed
            break
          default:
            break
        }
        const apiResp = await SpcmSessions.spcmSessionEdit(this, payload)
        ApiResponse.responseMessageDisplay(this, apiResp)
        if (apiResp.resp_status) {
          this.showSessionList = this.propViewList
          session.session_state = payload.session_state
        }
      }
      catch (error) {
        console.error("Exception in sessionStateChange", error)
      }
    },
    /**
     * payNow
     */
    async payNow (session) {
      this.subModuleName = this.sessionList.length > 1 ? "session_two" : "session_one"
      this.counsellorId = this.propSpcmObj.counsellor_id

      let payload = {
        spcm_id: this.propSpcmId,
        session_state: 1,
        session_id: session.session_id,
        counsellor_id: this.counsellorId
      }
      const apiResp = await SpcmSessions.spcmSessionEdit(this, payload)
      ApiResponse.responseMessageDisplay(this, apiResp)
      if (apiResp.resp_status) {
        this.showSessionList = true
        session.session_state = 1
      }
      else if (apiResp.resp_code === "ERR_SUBS_PLAN_PURCHASE_REQUIRED" || apiResp.resp_code === "ERR_SUBS_PLAN_LIMIT_OVER") {
        this.showPaymentModal = true
        this.showSessionList = true
        this.newSessionId = session.session_id
      }
    },
    /**
     * spcmCalendarAdd
     */
    spcmCalendarAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/spcmCalendar_add")
        }
        else {
          this.showModelSpcmCalenderAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCalendarAdd() and Exception:", err.message)
      }
    },
    /**
     * closeSpcmCalenderAddModal
     */
    closeSpcmCalenderAddModal () {
      let counsellor = {
        counsellor_id: this.propSpcmObj.counsellor_id,
        user_id: this.propSpcmObj.counsellor_id
      }
      this.getAvailableSlots(counsellor)
      this.showModelSpcmCalenderAdd = false
      this.getSessionList()
    },
    /**
     * spcmCalendarEdit
     */
    spcmCalendarEditV1 (item) {
      try {
        // Pass spcm_calendar_id to fetch data using current user's ID
        this.spcmCalendarEditObj = item
        this.showModelSpcmCalenderEdit = true
      }
      catch (err) {
        console.error("Exception occurred at spcmCalendarEdit() and Exception:", err.message)
      }
    },
    /**
     * editFails
     */
    editFails () {
      this.showModelSpcmCalenderEdit = false
      this.getSessionList()
    },
    /**
     * spcmSessionUpdate
     */
    spcmSessionUpdate (event) {
      if (event.session_id) {
        this.spcmObj.spcm_total_session += 1
      }
      this.selectedTab = this.cvTabObj.counselling
      this.showSlotModal = false
      // this.spcmAddEdit()
    },
    /**
     * showSpcmSession DeleteDialog
     */
    showSpcmSessionDeleteDialog (session) {
      try {
        this.delObj = session
        this.showModelSpcmSessionDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showSpcmSessionDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * SpcmSession Delete
     */
    async SpcmSessionDelete () {
      try {
        const resp = await SpcmSessions.spcmSessionDelete(this, this.delObj.session_id)
        ApiResponse.responseMessageDisplay(this, resp)

        if (!resp || !resp.resp_status) {
          this.showModelSpcmSessionDelete = false
          return
        }

        const index = this.sessionList.findIndex(s => s.session_id === this.delObj.session_id)
        if (index !== -1) this.sessionList.splice(index, 1)

        this.$nextTick(() => {
          this.showModelSpcmSessionDelete = false
          this.delObj = {}
        })
      }
      catch (err) {
        console.error("Exception occurred at SpcmSessionDelete()", err)
        this.showModelSpcmSessionDelete = false
      }
    },
    /**
     * Open add calendar appointment modal
     */
    addCalendarAppointment () {
      this.showModelSpcmCalenderAdd = true
    },
    /**
     * closeSpcmCalenderEditModal
     */
    closeSpcmCalenderEditModal () {
      try {
        this.showModelSpcmCalenderEdit = false
        this.spcmCalendarEditId = null
        this.spcmCalendarEditObj = null
        this.getSessionList()
        // Refresh available slots
        this.getAvailableSlots({ user_id: this.propSpcmObj.counsellor_id })
      }
      catch (err) {
        console.error("Exception occurred at closeSpcmCalenderEditModal() and Exception:", err.message)
      }
    },
    /**
     * Fetch categories from API to get color codes
     */
    async getSpcmCalendarCategoryList () {
      // Note: Adjust the API reference if your import name for categories is different
      const resp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this)
      if (resp && resp.resp_status) {
        this.spcmCalendarCategory = resp.resp_data.data
      }
    },
    /**
     * Get category color code by category name
     */
    getCategoryColor (categoryName) {
      if (!categoryName) return "#00cec9" // Default teal
      const category = this.spcmCalendarCategory.find(
        cat => cat.category_name.toLowerCase() === categoryName.toLowerCase()
      )
      return category ? category.color_code : "#00cec9"
    }
  }
}
</script>

<style lang="scss" scoped>
  .seesionBoxes {
    position: relative;
    width: 100%;
    padding: 15px 5px;
    text-align: left;
    .paidUnpaidLabel {
      text-align: center;
      display: block;
      position: relative;
      top: -10px;
    }
  }
  .btn_confirm{
    display: block;
    margin: auto;
    font-weight: 500;
  }
  .task-indicator {
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    width: 5px;
    border-radius: 8px 0 0 8px;
  }
  .buttons_right{
    display: flex !important;
    justify-content: flex-end !important;
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
